import script from "./InitiateSignIn.vue?vue&type=script&setup=true&lang=js"
export * from "./InitiateSignIn.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__